import React from "react";
import { Stack, Pagination } from "@mui/material";
import PropTypes from "prop-types";

import "./PoonaWallaPaginator.scss";

const PoonaWallaPaginator = ({
  isLoading,
  page,
  limit,
  count,
  handlePagination,
}) => {
  const totalPage = Math.ceil(count / limit);
  return (
    <>
      <div className="w-100 mt-2">
        <Stack spacing={2} className="PoonaWallaPaginator align-items-end">
          <Pagination
            page={page}
            count={totalPage}
            onChange={handlePagination}
            disabled={isLoading}
            className="text-primary"
          />
        </Stack>
      </div>
    </>
  );
};

export default PoonaWallaPaginator;

PoonaWallaPaginator.propTypes = {
  isLoading: PropTypes.bool,
  page: PropTypes.number,
  limit: PropTypes.number,
  count: PropTypes.number,
  handlePagination: PropTypes.func,
};
